import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
	},
	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});
		$('#navbar').affix({
			offset: {
				top: 250
			}
		});

	},

	methods: {

		navbarToggle: function () {

			var nav = this.$el;

			if (nav.className === "vo-nav-bar") {
				nav.className += " opened";
			} else {
				nav.className = "vo-nav-bar";
			}


		},
		favCount: favCount,
		goSearch: function () {
			console.log('ich wurde ausgelöst');
			if (isBlank(this.name)) {
				console.log('is blank');
				window.location.href = 's#';
			} else {
				console.log('is not blank');
				window.location.href = 's#?name=' + encodeURI(this.name);
			}
		}



	}
};